import React, { useCallback, useState } from "react";
import Emty from "../../components/Emty/Emty";
import UserCard from "../../components/UserCard/UserCard";
import UserFilter from "../../components/UserFilter/UserFilter";
import "./css/index.css";
import UseUserData from "../../hooks/UseUserData";
import CsvBtn from "../../components/CsvBtn/CsvBtn";
import { formatDate } from "../../lib/lib";
import Infinite from "../../components/Infinite/Infinite";
import { GetUser } from "../../api/userapi";

const csvHeader = [
  "유저넘버",
  "아이디",
  "닉네임",
  "이메일",
  "가입일",
  "마케팅 동의",
];

function Users() {
  const [isOpen, setIsOpen] = useState<undefined | string>(undefined);
  const [
    data,
    SearchUser,
    leaderInsert,
    LeaderDelete,
    RemoveUsers,
    PagingUpdate,
  ] = UseUserData({ limit: 30 });

  const CsvUserData = useCallback((): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const GetUserData = (idx: number, list: any[]) => {
        GetUser(undefined, idx + 1, 100000).then(({ data }) => {
          if (data) {
            const {
              pg: { page_cur, page_last },
            } = data;
            if (page_cur === page_last) {
              resolve(
                list.map(
                  ({
                    login_id,
                    login_nm,
                    usr_email,
                    def_reg_at,
                    agr_adv,
                    usr_id,
                  }) => {
                    return [
                      usr_id,
                      login_id,
                      login_nm ? login_nm : "-",
                      usr_email,
                      formatDate(def_reg_at, "-"),
                      agr_adv ? "동의" : "미동의",
                    ];
                  }
                )
              );
              return list;
            } else {
              GetUserData(idx + 1, [...list, ...data.lst]);
            }
          }
        });
      };
      GetUser(undefined, 1, 100000).then(({ data }) => {
        if (data) {
          const {
            pg: { page_cur, page_last },
          } = data;
          if (page_last > 1) {
            GetUserData(page_cur, data.lst);
          } else {
            resolve(
              data.lst.map(
                ({
                  login_id,
                  login_nm,
                  usr_email,
                  def_reg_at,
                  agr_adv,
                  usr_id,
                }) => {
                  return [
                    usr_id,
                    login_id,
                    login_nm ? login_nm : "-",
                    usr_email,
                    formatDate(def_reg_at, "-"),
                    agr_adv ? "동의" : "미동의",
                  ];
                }
              )
            );
          }
        }
      });
    });
  }, []);

  return (
    <main className="user-section">
      <div
        className="back-section"
        onClick={() => {
          setIsOpen(undefined);
        }}
      />
      <div className="wrapper">
        <div className="title-wrapper">
          <div className="title">팀플러 가입 목록</div>
          {data && (
            <CsvBtn
              headers={csvHeader}
              getCsvData={CsvUserData}
              title="팀플러 가입 목록"
            />
          )}
        </div>
        <UserFilter Search={SearchUser} />
        {data ? (
          <div className="list-wrapper">
            <div className="tag-wrapper">
              {tagarr.map((item, idx) => {
                return (
                  <div key={idx} className="tag">
                    {item}
                  </div>
                );
              })}
            </div>
            <div className="user-list">
              {data.map((item, idx) => {
                return (
                  <UserCard
                    key={idx}
                    data={item}
                    index={idx}
                    isopen={isOpen}
                    __setopen={setIsOpen}
                    remove={RemoveUsers}
                  />
                );
              })}
              <Infinite PagingUpdate={PagingUpdate} />
            </div>
          </div>
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default Users;

const tagarr = [
  "번호",
  "아이디",
  "이메일",
  "활동명",
  "프로젝트참여수",
  "마케팅 동의여부",
  "상세보기",
  "삭제하기",
];
